import { readOnly } from '@yola/ws-sdk';
import store from 'src/js/store';
import appControlDriverInstance from 'src/js/modules/read-only-mode/helpers/app-control-driver-instance';
import takeControl from 'src/js/modules/read-only-mode/operations/take-control';

const initialAppsCheck = async () => {
  const controlDriverInstance = appControlDriverInstance.get();

  const result = await controlDriverInstance.checkAppInstances();

  if (result?.id) {
    store.dispatch(readOnly.actions.enable());
  }
};

const appsCheckOnFocus = async () => {
  const controlDriverInstance = appControlDriverInstance.get();
  const result = await controlDriverInstance.checkAppInstances();

  if (!result?.id) {
    takeControl();
  } else {
    store.dispatch(readOnly.actions.enable());
  }
};

const checkAppsForReadOnly = async () => {
  await initialAppsCheck();
  let timer;
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearTimeout(timer);
      return;
    }

    // The timeout is needed for Firefox\Safari browsers. They need some time to lose active tab state,
    // when tabs is closed
    timer = setTimeout(appsCheckOnFocus, 200);
  });
};

export default checkAppsForReadOnly;
